import { render } from "./ParadigmGWP.vue?vue&type=template&id=b87992cc&scoped=true&ts=true"
import script from "./ParadigmGWP.vue?vue&type=script&lang=ts"
export * from "./ParadigmGWP.vue?vue&type=script&lang=ts"

import "./ParadigmGWP.vue?vue&type=style&index=0&id=b87992cc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87992cc"]])

export default __exports__